// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__2-966","cardHeader":"styles_cardHeader__1VsEX","buttons":"styles_buttons__302JI"};